import React from "react";
import { DateTime } from "luxon";

export default function MarketList({
  matches,
  operatorId,
  userId,
  tokenFromUrl,
}) {
  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "--";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour, minute, 0, 0);

    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getBettingStatus = (openTime, closeTime) => {
    const now = new Date();

    const [openHour, openMinute] = openTime.split(":").map(Number);
    const [closeHour, closeMinute] = closeTime.split(":").map(Number);

    const open = new Date();
    open.setHours(openHour, openMinute, 0, 0);

    const close = new Date();
    close.setHours(closeHour, closeMinute, 0, 0);

    const openTimeIST = openTime;
    const closeTimeIST = closeTime;

    // 1. Get current time in UAE
    const nowUAE = DateTime.now().setZone("Asia/Dubai");

    // 2. Convert to IST
    const nowIST = nowUAE.setZone("Asia/Kolkata");

    // 3. Today's date in IST
    const todayDate = nowIST.toFormat("yyyy-MM-dd");

    // 4. Build open and close DateTime in IST
    const openDateTimeIST = DateTime.fromFormat(
      `${todayDate} ${openTimeIST}`,
      "yyyy-MM-dd HH:mm:ss",
      {
        zone: "Asia/Kolkata",
      }
    );

    const closeDateTimeIST = DateTime.fromFormat(
      `${todayDate} ${closeTimeIST}`,
      "yyyy-MM-dd HH:mm:ss",
      {
        zone: "Asia/Kolkata",
      }
    );

    const closeWarningTime = closeDateTimeIST.minus({ minutes: 5 });
    const openWarningTime = openDateTimeIST.minus({ minutes: 5 });

    if (nowIST < openWarningTime) {
      return {
        status: "running",
        message: "Betting is Running Now",
      };
    }

    if (nowIST >= openWarningTime && nowIST < closeWarningTime) {
      return {
        status: "running_close",
        message: "Betting is Running for Close",
      };
    }
    if (nowIST >= closeWarningTime) {
      return {
        status: "closed",
        message: "Betting is Closed for Today",
        color: "text-red-500",
      };
    }
  };
  const getCleanResult = (value) =>
    value && value.trim() !== "" ? value : "***";
  const getCleanJodiResult = (value) => {
    const cleaned = value?.trim();
    return /^\d{2}$/.test(cleaned) ? cleaned : "**";
  };

  return (
    <div>
      {Object.entries(matches).map(([matchName, entries]) => {
        const data = entries[0];
        const openTime = data?.open_time;
        const closeTime = data?.close_time;
        const betDate = data?.draw_date;

        const { status, message } = getBettingStatus(openTime, closeTime);

        const singlePattiEntry = entries.find((item) => item?.type_id === 2);
        const jodiEntry = entries.find((item) => item?.type_id === 5);
        const jodiOpenEntry = entries.find((item) => item?.type_id === 1);
        const jodiClosentry = entries.find((item) => item?.type_id === 1);
        const jodiOpenResult = jodiOpenEntry?.open_result;
        const jodiCloseResult2 = jodiClosentry?.close_result;

        const singlePattiOpenResult = getCleanResult(
          singlePattiEntry?.open_result
        );
        const jodiCloseResult = getCleanJodiResult(jodiEntry?.close_result);
        const singlePattiCloseResult = getCleanResult(
          singlePattiEntry?.close_result
        );
           const isSinglePattiOpenPublished =
          singlePattiOpenResult && singlePattiOpenResult !== "***";
        const isSinglePattiClosePublished =
          singlePattiCloseResult && singlePattiCloseResult !== "***";
        const resultText1 =
          isSinglePattiOpenPublished && jodiOpenResult
            ? `${singlePattiOpenResult}-${jodiOpenResult}-***`
            : "***-**-***";

        const resultText2 =
          isSinglePattiOpenPublished &&
          isSinglePattiClosePublished &&
          jodiCloseResult
            ? `${singlePattiOpenResult}-${jodiCloseResult}-${singlePattiCloseResult}`
            : "***-**-***";
     

        const isValidResult = (res) =>
          res && !/^\*+$/.test(res.trim()) && res.trim() !== "";
        const resultTextCloseOnly =
          isSinglePattiClosePublished && jodiCloseResult2
            ? `***-${jodiCloseResult2}-${singlePattiCloseResult}`
            : "***-**-***";

        return (
          <a
            href={
              `/game-detail/api/${entries[0].match_name_id}/${operatorId}/${userId}?token=` +
              tokenFromUrl
            }
            key={matchName}
          >
            <div className="flex flex-col gap-3 mb-1">
              <div className="flex items-center justify-between bg-white rounded border border-m_gray shadow-md text-xs leading-[10px] px-2">
                <div className="w-1/4 text-center">
                  <div className="flex flex-col items-center gap-2">
                    <span className="font-semibold">Open Time</span>
                    <span>{formatTimeTo12Hour(openTime)}</span>
                  </div>
                </div>

                <div className="w-1/2 text-center py-1">
                  <span className="block font-semibold text-gray-800 text-lg">
                    {matchName}
                  </span>
                  <p
                    className={`text-xxs ${
                      status === "running"
                        ? "text-green-600"
                        : status === "running_close"
                        ? "text-green-600"
                        : status.startsWith("closed")
                        ? "text-m_red"
                        : ""
                    }`}
                  >
                    {message}
                  </p>
                  {/* <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                    {resultText}
                  </span> */}
                  {isSinglePattiOpenPublished && isSinglePattiClosePublished ? (
                    <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                      {resultText2}
                    </span>
                  ) : isSinglePattiOpenPublished ? (
                    <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                      {resultText1}
                    </span>
                  ) : isSinglePattiClosePublished ? (
                    <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                      {resultTextCloseOnly}
                    </span>
                  ) : (
                    <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                      ***-**-***
                    </span>
                  )}

                  {/* <p className="text-m_green pt-0.5 py-1 font-semibold">Play Game</p> */}
                  {/* <p className={`text-xxs ${statusColor}`}>{statusMessage}</p>
                  <span className="block text-sm text-m_peach1 font-bold pt-0.5 tracking-wider">
                    {result}
                  </span> */}
                </div>

                <div className="w-1/4 text-center">
                  <div className="flex flex-col items-center gap-2">
                    <span className="font-semibold">Close Time</span>
                    <span>{formatTimeTo12Hour(closeTime)}</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
}
